(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["delivery-timeline"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('delivery-timeline')){
 customElements.define('delivery-timeline',class extends HTMLElement{
  connectedCallback(){
   this.update=()=>{
    const now=new Date();
    const day=(offset)=>new Date(now.getFullYear(),now.getMonth(),now.getDate()+offset,12);
    const fmt=new Intl.DateTimeFormat(document.documentElement.lang||navigator.language,{day:'numeric',month:'short'});
    const range=(a,b)=>fmt.format(day(a))+' – '+fmt.format(day(b));
    const values=[fmt.format(day(0)),range(1,3),range(6,11)];
    this.querySelectorAll('[data-delivery-date]').forEach(el=>el.textContent=values[Number(el.dataset.deliveryDate)]);
   };
   this.update();this.timer=setInterval(this.update,60000);
   this.resume=()=>{if(!document.hidden)this.update();};
   document.addEventListener('visibilitychange',this.resume);
  }
  disconnectedCallback(){clearInterval(this.timer);document.removeEventListener('visibilitychange',this.resume);}
 });
}
  } catch(e) { console.error(e); }
})();

})();
